import {
  StyleSheet,
  Text,
  View,
  ScrollView,
  TextInput,
  TouchableOpacity
} from 'react-native'
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useNavigation } from '@react-navigation/native'
import { useDispatch, useSelector } from 'react-redux'
import { useToast } from 'react-native-toast-notifications'
import { Ionicons } from '@expo/vector-icons'

// styles
import globalStyles from '../styles/global'

// config
import { apiBaseUrl, reSiteKey } from '../config'

// components
import FlatButton from '../components/Button'
import { unsafeRegister } from '../redux/actions/userActions'

const RegisterScreen = () => {
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isPasswordHidden, setIsPasswordHidden] = useState(true)
  const [isConfirmPasswordHidden, setIsConfirmPasswordHidden] = useState(true)

  const dispatch = useDispatch()
  const navigation = useNavigation()
  const toast = useToast()

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo: userInfoLogin } = userLogin

  const userRegister = useSelector((state) => state.userRegister)
  const { loading, error, userInfo } = userRegister

  const registerHandler = () => {
    dispatch(
      unsafeRegister(
        username,
        email,
        password,
        confirmPassword,
        navigation,
        toast
      )
    )
  }

  useEffect(() => {
    if (userInfoLogin) navigation.navigate('Home', {})
  }, [navigation, userInfoLogin])

  return (
    <>
      {!userInfoLogin && (
        <ScrollView style={styles.container}>
          <View
            style={[globalStyles.secondaryBgColor, globalStyles.containerBand]}
          >
            {false && (
              <View style={[globalStyles.textOverlap]}>
                <View>
                  <Text
                    style={[
                      globalStyles.text,
                      globalStyles.fwMedium,
                      globalStyles.fs20,
                      globalStyles.blackTextColor,
                      globalStyles.mb1
                    ]}
                  >
                    Register
                  </Text>
                </View>
              </View>
            )}
          </View>
          <View style={[globalStyles.containerOverlap]}>
            <View style={[globalStyles.containerOverlapInner]}>
              <View style={styles.inputContainer} behavior="padding">
                <View style={[styles.inputLabelWrapper, { marginTop: -8 }]}>
                  <Text style={[styles.inputLabel]}>Username</Text>
                  <Text style={styles.inputLabelNote}>(required)</Text>
                </View>
                <TextInput
                  placeholder=""
                  value={username}
                  onChangeText={(text) => setUsername(text)}
                  style={styles.input}
                  required
                  autoCapitalize="none"
                />
                <Text style={styles.note}>
                  A valid username should start with an alphabet, then other
                  characters can be alphabets, numbers or underscores. When its
                  length consists of 6 to 28 characters and it's case
                  insensitive (e.g. hyusuf, yusuf22, Yusuf_22, h_yusuf_22).
                </Text>
                <View style={styles.inputLabelWrapper}>
                  <Text style={styles.inputLabel}>Email</Text>
                  <Text style={styles.inputLabelNote}>(required)</Text>
                </View>
                <TextInput
                  placeholder=""
                  value={email}
                  onChangeText={(text) => setEmail(text)}
                  style={styles.input}
                  required
                  autoCapitalize="none"
                />
                <View style={styles.inputLabelWrapper}>
                  <Text style={styles.inputLabel}>Password</Text>
                  <Text style={styles.inputLabelNote}>(required)</Text>
                </View>
                <View style={styles.passwordField}>
                  <TextInput
                    placeholder=""
                    value={password}
                    onChangeText={(text) => setPassword(text)}
                    style={styles.input}
                    secureTextEntry={isPasswordHidden}
                    autoCapitalize="none"
                  />
                  <TouchableOpacity
                    style={styles.eyeIcon}
                    onPress={() => setIsPasswordHidden(!isPasswordHidden)}
                  >
                    <Ionicons
                      name={`${
                        isPasswordHidden
                          ? 'ios-eye-outline'
                          : 'ios-eye-off-outline'
                      }`}
                      size={24}
                      color="rgba(0,0,0,.25)"
                    />
                  </TouchableOpacity>
                </View>
                <Text style={styles.note}>
                  Password must be at least 8 characters. And must contain
                  letters, numbers, symbols (e.g. @yusuf123, Yusuf2022$).
                </Text>
                <View style={styles.inputLabelWrapper}>
                  <Text style={styles.inputLabel}>Confirm Password</Text>
                  <Text style={styles.inputLabelNote}>(required)</Text>
                </View>
                <View style={styles.passwordField}>
                  <TextInput
                    placeholder=""
                    value={confirmPassword}
                    onChangeText={(text) => setConfirmPassword(text)}
                    style={styles.input}
                    secureTextEntry={isConfirmPasswordHidden}
                    autoCapitalize="none"
                  />
                  <TouchableOpacity
                    style={styles.eyeIcon}
                    onPress={() =>
                      setIsConfirmPasswordHidden(!isConfirmPasswordHidden)
                    }
                  >
                    <Ionicons
                      name={`${
                        isConfirmPasswordHidden
                          ? 'ios-eye-outline'
                          : 'ios-eye-off-outline'
                      }`}
                      size={24}
                      color="rgba(0,0,0,.25)"
                    />
                  </TouchableOpacity>
                </View>
                <View style={styles.buttonContainer}>
                  <FlatButton
                    text="Register"
                    transform="uppercase"
                    type="primary"
                    onPress={registerHandler}
                  />
                </View>
                <View style={[globalStyles.separator]}></View>
                <View style={styles.copyContainer}>
                  <Text style={styles.copyText}>Already have an account?</Text>
                  <TouchableOpacity
                    onPress={() => navigation.navigate('Login')}
                  >
                    <Text style={styles.copyLink}>Login</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </View>
        </ScrollView>
      )}
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff'
  },
  inputContainer: {
    marginVertical: 0,
    padding: 16
  },
  input: {
    borderWidth: 1,
    backgroundColor: '#fff',
    borderColor: '#e9ecef',
    paddingHorizontal: 16,
    height: 46,
    fontSize: 16,
    lineHeight: 21,
    borderRadius: 6,
    marginVertical: 4,
    fontFamily: 'notosanstc-medium'
  },
  inputLabelWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10
  },
  inputLabel: {
    color: '#333',
    fontFamily: 'notosanstc-medium',
    fontSize: 14,
    lineHeight: 19,
    marginBottom: 0,
    marginTop: 16,
    marginHorizontal: 1
  },
  inputLabelNote: {
    color: 'rgba(0,0,0, .7)',
    fontFamily: 'notosanstc-light',
    fontSize: 11,
    lineHeight: 16,
    marginBottom: 0,
    marginTop: 16,
    marginHorizontal: 3
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginVertical: 16
  },
  copyContainer: {
    flexDirection: 'row'
    // marginTop: 4
  },
  copyText: {
    color: '#333',
    fontFamily: 'notosanstc-light',
    marginHorizontal: 1,
    fontSize: 14,
    lineHeight: 19
  },
  copyLink: {
    color: '#df143c',
    marginLeft: 5,
    borderBottomColor: '#df143c',
    fontFamily: 'notosanstc-bold',
    fontSize: 14,
    lineHeight: 19
  },
  note: {
    fontFamily: 'notosanstc-light',
    fontSize: 11,
    lineHeight: 16,
    color: 'rgba(0,0,0, .7)'
  },
  passwordField: {
    position: 'relative',
    marginHorizontal: 0
  },
  eyeIcon: {
    position: 'absolute',
    right: 12,
    top: 15.5
  }
})

export default RegisterScreen
